import styled from 'styled-components';

export const MatrixTableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
  min-height: auto;
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableRow = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
`;

export const TableCell = styled.div`
  min-width: 120px;
  max-width: 120px;
  color: ${(props) => props.theme.color.textSecondary};
  align-items: center;
  justify-content: center;
  text-align: ${(props) => (props.row ? 'left' : 'center')};
`;

export const ResultBox = styled.div`
  min-width: 80px;
  min-height: 20px;
  text-align: center;
  color: ${(props) => props.theme.color.textSecondary};
  border-radius: 8px;
  padding: 8px;
  margin: 4px;
  align-items: center;
  justify-content: center;
  border: 1px solid #CECFCF;
  background-color: ${(props) => {
  const { percentage } = props;
  if (percentage < 20) {
    return '#FFFFFF';
  } if (percentage >= 20 && percentage <= 50) {
    return '#E3E8F5';
  } if (percentage > 50 && percentage <= 80) {
    return '#BED0FF';
  } if (percentage > 80 && percentage <= 100) {
    return '#7F9FF0';
  }
  return '#FFFFFF';
}};
`;
